import { useSelector } from "react-redux";
import { useMemo } from "react";
import { extractEntitiesFromRedux } from "../Components/Common/AutocompleteTextarea/entityUtils";

/**
 * Custom hook that extracts entities from Redux store for autocomplete
 * @param {Array<string>} entityTypes - Array of entity types to include: ['players', 'metrics', 'positions', 'playerGroups', 'sessions']
 * @returns {Array<Object>} Array of normalized entities ready for autocomplete
 */
export function useAutocompleteEntities(entityTypes = []) {
	const teamState = useSelector((state) => state.team);

	// Callers pass inline array literals, so key the memo on contents rather than identity.
	// An unstable `entities` reference rebuilds the CodeMirror extensions on every render,
	// which makes the editor reconfigure itself in a loop (React #185).
	const typesKey = (entityTypes || []).join("\u0000");

	const entities = useMemo(() => {
		if (!teamState || !typesKey) {
			return [];
		}

		return extractEntitiesFromRedux(teamState, typesKey.split("\u0000"));
	}, [teamState, typesKey]);

	return entities;
}

